import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './emaileditor.routes';
import addHtml from './modal/add.html';

export class EmailEditorController {
    $http;
    socket;
    awesomeThings = [];
    emaileditors = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        // $scope.$on('$destroy', function() {
        //   socket.unsyncUpdates('search');
        // });
    }

    $onInit() {
        this.IsHidden = false;
        if (this.$cookies.get('token')) {
            this.$http.get('/api/email_editor/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.emaileditors = response.data.data;
                        this.socket.syncUpdates('emaileditors', this.emaileditors);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);



        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/email_editor/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.emaileditors = response.data.data;
                        this.socket.syncUpdates('emaileditors', this.emaileditors);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    addSpeechType() {

        this.IsHidden = true;

        this.vm = {};

        this.ready = function (editor) {
            console.log(editor);
        }

        const emaileditors = this.emaileditors;


        this.save = function (myForm) {
            if (myForm.$valid === false) {
                return false;
            } else {
                console.log(this.vm);
                // this.$http.post('/api/email_editor/', this.vm).then((response) => {
                //     emaileditors.push(response.data.data);
                // }, (error) => {
                //     console.log(error);
                // });
            }
        };

        this.cancel = function () {
            this.IsHidden = false;
        };

    }


    editSpeechType(type, index) {
        const emaileditors = this.emaileditors;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.vm = angular.copy(type);
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {

                        $http.put('/api/email_editor/' + type._id + '/', $scope.vm).then((response) => {
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    emaileditors[index] = ret;
                }
            }, function () {
            });
    }



    deleteSpeechType(type, index) {
        this.$http.delete('/api/email_editor/' + type._id + '/').then(response => {
            if (response.status === 204) {
                this.emaileditors.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.emaileditor', [uiRouter])
    .config(routing)
    .component('emaileditor', {
        template: require('./emaileditor.html'),
        controller: EmailEditorController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/emaileditor/emaileditor.component.js